import { CandidateInterviewFormData } from ".";

export class CandidateInterviewResult {
    candidateInterviewId?: number;
    interviewDate: string;
    interviewTime: string;
    durationHours: number;
    durationMinutes: number;
    timeZoneId: number;
    interviewTypeId: number;
    interviewStatusTypeId: number;
    amPm: string;
    interviewDetails?: string;
    sendNotification: boolean;

    private constructor(formData: CandidateInterviewFormData) {
        const durationMinutes =
            (Math.round(formData.durationMinutes / 15) * 15) % 60;
        this.candidateInterviewId = formData.candidateInterviewId;
        this.interviewDate = formData.interviewDate;
        this.interviewTime = formData.interviewTime;
        this.durationHours = formData.durationHours;
        this.durationMinutes = durationMinutes;
        this.timeZoneId = formData.timeZoneId;
        this.interviewStatusTypeId = formData.interviewStatusTypeId;
        this.interviewTypeId = formData.interviewTypeId;
        this.interviewDetails = formData.interviewDetails;
        this.sendNotification = formData.sendNotification;
    }

    static create(incoming: CandidateInterviewFormData) {
        return new CandidateInterviewResult(incoming);
    }
}
